import { CacheFlags } from 'types/cacheTypes';

export const createInvalidatedCacheFlags = (): CacheFlags => ({
  prodStackManagerData: true,
});
